import React, {useContext, useState, useEffect} from "react";
// data
import data from "../../../../data"
// components
import {Helmet} from "react-helmet";
import {Block, Scaffolding} from "../../../shared";
import {ActivityLink} from "../../../controls";
// context
import {CatalogueContext} from "../../../../context"

// styling
import "./ActivityNotFound.scss";

function ActivityNotFound() {
  // context
  let catalogue = useContext(CatalogueContext)

  // state 
  const [activities, setActivities] = useState(null);

  // process side effects
  useEffect(() => {
    if(catalogue.isReady) {
      setActivities(data.Catalogue.getRandomActivities(6));
    }
  }, [catalogue.isReady])

  // render
  let content = null;
  if(activities) {
    content = activities.map(a => <ActivityLink activity={a} key={a._id} />)
  }
  const helmetName = "Appentura - Erlebnis nicht gefunden";
  return (
    <Scaffolding>
      <Block>
        <Helmet>
          <title>{helmetName}</title>
          <meta id="meta-description" name="description" content={helmetName} />
          <meta id="og-title" property="og:title" content={helmetName} />
        </Helmet>
        <div id="v-activity-not-found">
          <h1>Hmmm ... leider konnte ich das nicht finden</h1>
          <p>... aber zum Glück haben wir noch viele andere Erlebnisse im Angebot, zum Beispiel</p>
          <div id="v-activity-not-found-activities">
            {content}
          </div>
        </div>
      </Block>
    </Scaffolding>
  )
}

export default ActivityNotFound